import { useRequestConfirm } from './hooks';
import { RequestConfirmTemplate } from 'views/components/templates/establishes';

export const RequestConfirm = () => {
  const tempProps = useRequestConfirm();
  return <RequestConfirmTemplate {...tempProps} />;
};
